import React from 'react';
import styled from 'styled-components';
import { Button } from '../../test/components/ui';
import { useDispatch, useSelector } from 'react-redux';
import { AppStore } from '../../store/applicationState';
import { ClickCallAction, GetCallAction } from '../../store/callToAction/actions';
import { EIcons } from '../../utils/globatTypes';
import { TCallToAction } from '../../store/callToAction/types';
import { useCloseInfoWindow } from './hooks/useCloseInfoWindow';

interface CallToActionProps {}

export const CallToAction: React.FC<CallToActionProps> = () => {
  const { CallToAction: RCallToAction, Sockets } = useSelector((store: AppStore) => store);
  const { isClose, closeWindow } = useCloseInfoWindow(RCallToAction.data, 1);

  const dispatch = useDispatch();

  const { data: callToAction } = RCallToAction;
  const { room } = Sockets;

  React.useEffect(() => {
    if (room?.callActionId) {
      dispatch(
        GetCallAction.request({
          data: {
            event_id: room.event_id,
            roomId: room.absnum,
            callActionId: room.callActionId,
          },
        })
      );
    }
  }, [room, dispatch]);

  const handleClick = () => {
    if (callToAction) {
      window.open(callToAction.urlBtn);
      dispatch(
        ClickCallAction.request({
          data: {
            event_id: callToAction.eventId,
            roomId: callToAction.roomId,
            callActionId: callToAction.id,
          },
        })
      );
    }
  };

  const handleClickToAction = () => {
    if (callToAction) {
      dispatch(
        ClickCallAction.request({
          data: {
            event_id: callToAction.eventId,
            roomId: callToAction.roomId,
            callActionId: callToAction.id,
          },
        })
      );
    }
  };

  if (!callToAction) {
    return null;
  }

  if (callToAction.typeBtn === 2) {
    return <Popup callToAction={callToAction} onClick={handleClick} />;
  }

  return (
    <MainS>
      <div
        style={{
          textAlign: 'center',
          marginRight: '50px',
        }}
      >
        {callToAction.countClicks}
      </div>
      <div style={{ position: 'relative' }}>
        {!isClose && <Popup callToAction={callToAction} onClick={() => closeWindow(callToAction.id)} />}{' '}
        <ImgS src={callToAction.urlImg} alt="alt" onClick={handleClickToAction} />
      </div>
    </MainS>
  );
};

interface PopupProps {
  callToAction: TCallToAction;
  onClick: () => void;
}

const Popup: React.FC<PopupProps> = React.memo(({ callToAction, onClick }) => {
  const { isClose, closeWindow } = useCloseInfoWindow(callToAction, 2);
  return (
    <>
      {(!isClose && callToAction.typeBtn === 2) || (isClose && callToAction.typeBtn === 1) ? (
        <PopupS type={callToAction.typeBtn}>
          <div>
            <div>{callToAction.text}</div>
            {callToAction.typeBtn === 2 ? (
              <WrapIcon onClick={() => closeWindow(callToAction.id)}>
                <i className={EIcons.close} />
              </WrapIcon>
            ) : null}
          </div>
          <div>
            <Button
              onClick={() => {
                closeWindow(callToAction.id);
                onClick();
              }}
              title={callToAction.nameBtn}
            />
          </div>
        </PopupS>
      ) : (
        <WrapBtn>
          <Button onClick={onClick} title={callToAction.nameBtn} />
        </WrapBtn>
      )}
    </>
  );
});

const MainS = styled.div`
  position: absolute;
  right: 0px;
  bottom: 0px;
  color: black;
  margin: 0 50px 65px;
  background-color: white;
  display: flex;
  align-items: center;
  border-radius: 30px;
  padding: 10px 0px 10px 15px;
`;

const ImgS = styled.img`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 45px;
  height: auto;
  transform: translate(-85%, -50%);
  cursor: pointer;
  background-color: orange;
  border-radius: 30px;
  border: solid 3px #a5a53b;
  box-shadow: 0 0 5px 5px #099609a3;
`;

const PopupS = styled.div<{ type: number }>`
  position: absolute;
  background-color: #fff;
  right: 0px;
  bottom: 0px;
  width: 300px;
  padding: 15px;
  box-shadow: 0 0 10px rgb(0 0 0 / 50%);
  ${({ type }) =>
    type === 1
      ? `
      transform: translate(3%, -30%);
      &::after,
      &::before {
        content: '';
        position: absolute;
        right: 15px;
        bottom: -20px;
        border: 10px solid transparent;
        border-top: 10px solid white;
      }
      &::after {
        border-top: 10px solid white;
        bottom: -19px;
      }`
      : `
      transform: translate(-10%,-60%);
      `}

  & > * {
    &:nth-child(1) {
      display: flex;
      justify-content: space-between;
    }

    &:nth-child(2) {
      padding-top: 20px;
      text-align: end;
    }
  }
`;

const WrapIcon = styled.div`
  cursor: pointer;
`;

const WrapBtn = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  background-color: #fff;
  transform: translate(-44%, -164%);
`;
